import React from "react";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";
import { ModalStore } from "store/modalStore";

export const InfoModal = ({ data, closeModal }: { data: ModalStore; closeModal: () => void }) => {
  const closeModalWithAction = () => {
    closeModal();
    data?.info?.onClose?.();
  };
  if (!data?.info) return null;
  return (
    <Modal onClose={closeModalWithAction} isOpen={data?.info?.modalState === "open"}>
      <div className="relative flex h-[250px] w-[400px] flex-col items-center pb-5">
        <div className="relative flex h-5/6 flex-col items-center justify-center text-center">
          <div className="item-center flex items-center justify-center">
            <p className="text-[19.2px]">{data?.info?.infoMessage}</p>
          </div>
          <p className="relative mt-4 text-16px">{data.info.subMessage}</p>
        </div>
        <div className="absolute bottom-0 flex justify-center gap-4 py-5">
          <Button style={ButtonStyle.OUTLINE} onClick={closeModalWithAction} text={"閉じる"} width="w-[160px]" />
        </div>
      </div>
    </Modal>
  );
};
